/**
 * api - 傳輸層
 * 二級驗證 - 掃碼登入
 */

import http from "@/v2/api"

/**
 * 基礎 - 路徑
 */
const baseUri = "/api/factory/qrcode"

/**
 * 掃碼登入 - 顯示端 - 輪詢狀態
 *
 * 取代原 /websocket/notify 推播。
 * token 為顯示端自產的識別碼（= sys_factory.uuid，也是打 /qrcode/factory 時送出的 token）。
 * 回應為裸格式無 code 欄位，必須關閉全局錯誤攔截，否則每輪都會被判為失敗。
 */
export const getFactoryQrcodeStatus = (
    token
) => {
    return http.get(
        `${baseUri}/status`,
        {token},
        {
            opts: {
                default: {
                    failure: false
                }
            }
        }
    )
}
